module.exports = __webpack_public_path__ + "img/20191129165900370.31ed863d.jpg";